import React from "react";

const GuaranteeComponent = () => {
  return (
    <div className="w-full max-w-5xl mx-auto px-4">
      <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 border-t border-b border-gray-100 py-10">

        {/* Big number */}
        <div className="shrink-0 text-center">
          <span
            className="text-8xl md:text-9xl font-extrabold text-green-700 leading-none tracking-tight"
            style={{ fontFamily: "P22 Mackinacpro, sans-serif" }}
          >
            14
          </span>
          <p className="text-sm font-bold uppercase tracking-widest text-green-700 mt-1">days free</p>
        </div>

        {/* Divider */}
        <div className="hidden md:block w-px h-20 bg-gray-200 shrink-0" />

        {/* Copy */}
        <div className="text-center md:text-left max-w-sm">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight mb-2 leading-snug">
            Try any plan, on us.
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Pick the plan that fits your store and get full access for 14 days — no limits, no commitments. Your trial starts the moment you're in.
          </p>
        </div>

      </div>
    </div>
  );
};

export default GuaranteeComponent;
